import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id B7B431BB-E448-47F4-A7DC-03CCCA93C3D1
 * name inbox-arrow-down-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/inbox-arrow-down-outline.svg
 * tags
 */
export const InboxArrowDownOutlineIcon = createSvgIcon(<><path d="M19 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V5A2 2 0 0 0 19 3M5 19V17H8.13A4.13 4.13 0 0 0 9.4 19M19 19H14.6A4.13 4.13 0 0 0 15.87 17H19M19 15H14V16A2 2 0 0 1 10 16V15H5V5H19M16 10H14V7H10V10H8L12 14" /></>, 'InboxArrowDownOutlineIcon');
export default InboxArrowDownOutlineIcon